export const environment = {
    production: true,
    apiURL: 'https://fedformsfire.federale.be/fedformsfireapi/',
    mapKey: 'AIzaSyCniw0GRnuszcymYPoX4l9i1BfN8dddC10',
    name: 'Prod',
    esbuser: 'BIZTALKPRDUSERESB',
    myFederale: 'https://my.federale.be/Login.aspx?lang=',
    wwwFederale: 'https://www.federale.be/'
  };